export const language = {
  en: {
    'Confirm': 'Confirm',
    'Edit': 'Edit',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'Please Entry': 'Please Entry',

    'Business License': 'Business License',
    'Legal Person Certificate': 'Legal Person Certificate',
    'Company Certificate': 'Company Certificate',
    'Account Opening Permit Certificate': 'Account Opening Permit Certificate',
    'Road Transport Permits': 'Road Transport Permits',
    'Proof Of Tax Eligibility': 'Proof Of Tax Eligibility',
    'Proof Of Business Performance': 'Proof Of Business Performance',
    'Upload Files': 'Upload Files',
    'Upload': 'Upload',
    'Support Extension': 'Support Extension',
    'Certification': 'Certification',
  },
  zh: {
    'Confirm': '确认',
    'Edit': '编辑',
    'Save': '保存',
    'Cancel': '取消',
    'Please Entry': '请输入',

    'Business License': '营业执照',
    'Legal Person Certificate': '法人证件',
    'Company Certificate': '公司资质',
    'Account Opening Permit Certificate': '开户许可证',
    'Road Transport Permits': '道路运输许可证',
    'Proof Of Tax Eligibility': '纳税人资格证明',
    'Proof Of Business Performance': '经营业绩证明',
    'Upload Files': '上传文件',
    'Upload': '上传',
    'Support Extension': '支持扩展名',
    'Certification': '资质',
  }
};
